<template>
    <div>
        <Header />
        <main class="app-content">
            <div class="app-title">
                <div>
                    <h1><i class="fa fa-dashboard"></i>YAZILAN ÇEK LİSTESİ</h1>
                </div>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
                    <li class="breadcrumb-item"><a href="#">YAZILAN ÇEK LİSTESİ</a></li>
                </ul>
            </div>
            <br>
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <form>
                        <div class="form-group">
                            <label class="control-label">DEVAMINA YAZILAN ÇEK TOPLAM TUTARI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS"><strong>{{ maincheck.toplamcekodemesi }}</strong>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-4 col-md-4">
                    <form>
                        <div class="form-group">
                            <label class="control-label">ÇEK DEVAMINA YAZILAN ÇEK SAYISI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972; font-size:bold"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS"><strong>{{ maincheck.toplamcek }}</strong></div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-4 col-md-4">
                    <form>
                        <div class="form-group">
                            <label class="control-label">TOPLAM BOŞTA ÇEK MİKTARI:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS"><strong>{{ maincheck.tutar }}</strong></div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">OCAK AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.ocak }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">ŞUBAT AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.subat }}</div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">MART AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.mart }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">NİSAN AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.nisan }}</div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">MAYIS AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{months.mayis }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">HAZİRAN AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{months.haziran }}</div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">TEMMUZ AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{months.temmuz }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">AĞUSTOS AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.agustos }}</div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">EYLÜL AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.eylul }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">EKİM AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.ekim }}</div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">KASIM AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.kasim }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-2 col-md-2">
                    <form>
                        <div class="form-group">
                            <label class="control-label">ARALIK AYI BOŞTA ÇEK DURUMU:</label>
                            <div class="form-control" type="text" style="max-width: 100%; background-color : #86e972"
                                placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS">{{ months.aralik }}</div>
                        </div>
                    </form>
                </div>
            </div>
            <br>

            <div class="row">
                <div class="col-md-12">
                    <div class="tile">
                        <div class="tile-body">
                            <table class="table table-hover table-bordered" id="sampleTable">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Firma Adı</th>
                                        <th>Tutar</th>
                                        <th>Vade</th>
                                        <th>Açıklama</th>
                                        <th>Banka</th>
                                        <th>Seri No</th>
                                        <th>Kayıt Tarihi</th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <Sidebar />
    </div>
</template>
<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import { debounce } from "lodash";
import { result } from "lodash";
export default {
    data() {
        return {
            searchString: "",
            results: [],
            maincheck: [],
            months: [],
            product: [],
            maincontent: [],
            id: this.$route.query.idm,
            result: {
                id: "",
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                tc_number: "",
                imgSrc: "",
                imgUrl: "",
            },
            file: "",
            fileWarn: "",
        };
    },
    watch: {
        searchString: debounce(function () {
            this.search();
        }, 250),
        $route() {
            $("#navbarSupportedContent").collapse("hide");
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        var token = localStorage.getItem("token");
        if (!token) {
            this.$router.push("/");
        }
        var results = this.result;
        let datas = {
            id: this.id
        };

        let url = store.state.base_url + "Cek/getAllChecks.php?key=123";
        var datas2 = {
            id: localStorage.getItem("id"),
            token: localStorage.getItem("token"),
            checkId: this.id,
        };

        axios
            .post(url, JSON.stringify(datas2))
            .then((response) => {
                datas2 = response.data.data;
                this.maincheck = response.data.main;
                this.months = response.data.months;
                var table = $("#sampleTable").DataTable(
                    {
                        pageLength: 30,
                        order: [[3, 'asc']]
                    }
                );
                $.each(datas2, function (index, value) {
                    table.row
                        .add([
                            value["id"],
                            value["firmaname"],
                            new Intl.NumberFormat('tr-TR', {
                                style: 'currency',
                                currency: 'TRY'
                            }).format(value["tutar"]),
                           
                            value["vade"],
                            value["content"],
                            value["banka"],
                            value["serino"],
                            value["regdate"],
                        ])
                        .draw(false);
                });

                $("#sampleTable tbody").on("click", "tr", function () {
                    var data = table.row(this).data();
                    results.id = data[0];
                    window.location.href = "#/updateCheck?id=" + results.id;
                });
            })
            .catch((err) => {
                //console.log(err.response);
            });
    },

    methods: {
        routeDetail: function (item) {
            window.location.href = "#/updateCheck?id=" + item.id;
        },
        goProducts: function () {
            console.log("deneme");
            this.router.navigate(["/staff_detail"], {
                queryParams: { new_id: this.result.id },
            });
            console.log(this.results.id);
        },
        async getFilteredUsers() {
            const filteredUsers = await fetch(
                ' https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/getAllGider.php'
            );
            this.users = await filteredUsers.json();
        },
        search: function () {
            if (this.searchString.length > 0) {
                axios
                    .get(
                        `https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/searchRapor.php?key=123&keyword=${this.searchString}`
                    )
                    .then((response) => {
                        var deger = response.data.length;
                        if (deger > 50) {
                            this.results = response.data.slice(0, 50);
                        } else {
                            this.results = response.data;
                        }
                    });
            } else {
                this.results = null;
            }
        },
    },

    components: {
        Header,
        Sidebar,
    },
};
</script>
<style>
.searchCss {
    border-radius: 6px;
    background-color: rgb(215, 98, 98);
}
</style>


// WEBPACK FOOTER //
// src/components/ChecksCariList.vue